import { BillOfMaterialsUnitFormModel } from '../../bill-of-materials/billOfMaterialsUnitFormModel';
import {
  CreateUpdateBillOfMaterialsItemDto,
  mapBillOfMaterialsItemFormModelToDto,
} from '../../bill-of-materials/createUpdateBillOfMaterialsItemDto';
import {
  CreateUpdateBillOfMaterialsOptionalExtraDto,
  mapBillOfMaterialsOptionalExtraFormModelToDto,
} from '../../bill-of-materials/createUpdateBillOfMaterialsOptionalExtraDto';
import { EditDesignBillOfMaterialsFormModel } from './editDesignBillOfMaterialsFormModel';

export type UpdateDesignBillOfMaterialsCommand = {
  designId: number;
  units: Array<UpdateDesignBillOfMaterialsUnitDto>;
  optionalExtras: Array<CreateUpdateBillOfMaterialsOptionalExtraDto>;
};

type UpdateDesignBillOfMaterialsUnitDto = {
  billOfMaterialsUnitId: number;
  items: Array<CreateUpdateBillOfMaterialsItemDto>;
};

export const mapEditDesignBillOfMaterialsFormModelToCommand = (
  {
    units,
    underfloorHeatingControlOptionalExtras,
    underfloorHeatingFloorConstructionOptionalExtras,
    underfloorHeatingCylinderOptionalExtras,
    heatPumpOptionalExtras,
    solarOptionalExtras,
  }: EditDesignBillOfMaterialsFormModel,
  designId: number,
): UpdateDesignBillOfMaterialsCommand => ({
  designId,
  units: units.map(mapBillOfMaterialsUnitFormModelToDesignDto),
  optionalExtras: [
    ...underfloorHeatingControlOptionalExtras.map(extra =>
      mapBillOfMaterialsOptionalExtraFormModelToDto(extra, 'UnderfloorHeating', 'Control'),
    ),
    ...underfloorHeatingFloorConstructionOptionalExtras.map(extra =>
      mapBillOfMaterialsOptionalExtraFormModelToDto(extra, 'UnderfloorHeating', 'FloorConstruction'),
    ),
    ...underfloorHeatingCylinderOptionalExtras.map(extra =>
      mapBillOfMaterialsOptionalExtraFormModelToDto(extra, 'UnderfloorHeating', 'Cylinder'),
    ),
    ...heatPumpOptionalExtras.map(extra => mapBillOfMaterialsOptionalExtraFormModelToDto(extra, 'HeatPump', null)),
    ...solarOptionalExtras.map(extra => mapBillOfMaterialsOptionalExtraFormModelToDto(extra, 'Solar', null)),
  ],
});

const mapBillOfMaterialsUnitFormModelToDesignDto = ({
  billOfMaterialsUnitId,
  underfloorHeatingItems,
  heatPumpItems,
  solarItems,
}: BillOfMaterialsUnitFormModel): UpdateDesignBillOfMaterialsUnitDto => ({
  billOfMaterialsUnitId,
  items: [
    ...underfloorHeatingItems.map((formModel, index) =>
      mapBillOfMaterialsItemFormModelToDto(formModel, index, 'UnderfloorHeating'),
    ),
    ...heatPumpItems.map((formModel, index) => mapBillOfMaterialsItemFormModelToDto(formModel, index, 'HeatPump')),
    ...solarItems.map((formModel, index) => mapBillOfMaterialsItemFormModelToDto(formModel, index, 'Solar')),
  ],
});
